import { getFEWalletParams } from "./platform.pay.config";

export const DefaultDate = {
    F1M1: {

    },
    F1M2: {
        APP: {
            mgmtRefNo: "Fun88MobileApps",
            clientId: "Fun88.TH.APP",
            clientSecret: "FUNmuittenTH",
            language: "th-th",
            appId: "net.gb2bc.fun.thb",
            swiftCode: "Fun88MobileApps",
            currencyCode: "THB",
            isMobile: true,
            xBffKey: "I8lVSVRQNUSGY8Tg1WoEzQ=="
        },
        MOB: {
            mgmtRefNo: "fun88Mobile",
            clientId: "Fun88.TH.Mobile",
            clientSecret: "FUNmuittenTH",
            language: "th-th",
            appId: "net.gb2bc.fun.thb",
            swiftCode: "Fun88MobileApps",
            currencyCode: "THB",
            isMobile: true,
            xBffKey: "51EXaTN7NUeCbjnvg95tgA=="
        },
        WEB: {
            mgmtRefNo: "fun88Desktop",
            clientId: "Fun88.TH.Desktop",
            clientSecret: "FUNmuittenVN",
            language: "th-th",
            appId: "net.gb2bc.fun.thb",
            swiftCode: "Fun88DesktopApps",
            currencyCode: "THB",
            isMobile: false,
            xBffKey: "51EXaTN7NUeCbjnvg95tgA=="
        }
    },
    F1M3: {
        APP: {
            mgmtRefNo: "Fun88MobileApps",
            clientId: "Fun88.VN.APP",
            clientSecret: "FUNmuittenVN",
            language: "vi-vn",
            appId: "net.gb2bc.fun.vnd",
            swiftCode: "Fun88MobileApps",
            currencyCode: "VND",
            isMobile: true,
            xBffKey: "I8lVSVRQNUSGY8Tg1WoEzQ=="
        },
        MOB: {
            mgmtRefNo: "fun88Mobile",
            clientId: "Fun88.VN.Mobile",
            clientSecret: "FUNmuittenVN",
            language: "vi-vn",
            appId: "net.gb2bc.fun.vnd",
            swiftCode: "Fun88MobileApps",
            currencyCode: "VND",
            isMobile: true,
            xBffKey: "51EXaTN7NUeCbjnvg95tgA=="
        },
        WEB: {
            mgmtRefNo: "fun88Desktop",
            clientId: "Fun88.VN.Desktop",
            clientSecret: "FUNmuittenVN",
            language: "vi-vn",
            appId: "net.gb2bc.fun.vnd",
            swiftCode: "Fun88DesktopApps",
            currencyCode: "VND",
            isMobile: false,
            xBffKey: "51EXaTN7NUeCbjnvg95tgA=="
        }
    },
}


// export default DefaultDate
export const PParamsData = () => {
    const FEWalletParams = getFEWalletParams();
    return DefaultDate[FEWalletParams.platformType + FEWalletParams.languageType][FEWalletParams.device];
}
